import { createSelector } from "@reduxjs/toolkit";

import { nodeDesignsByIdSelector } from "./nodeDesignsCoreSelectors.ts";
import { nodeIdParamSelector } from "./paramSelectors.ts";

export const nodeTypeIdSelector = createSelector(
  nodeDesignsByIdSelector,
  nodeIdParamSelector,
  (designsById, nodeId) => designsById[nodeId].typeId,
);

export const getNodeTypeIdSelector = createSelector(
  nodeDesignsByIdSelector,
  (designsById) => (nodeId: number) => designsById[nodeId].typeId,
);
